import actions from './actions'
import mutations from './mutations'

const clientRefillHistory = {
    namespaced: true,
    state: {
        clientRefillHistory: [],
        isLoaded: false,
        pagination: {
            length: null,
            page: 1,
            total: null
        },
        filters: {
            phoneNumber: null,
            email: null,
            fromDate: new Date(+new Date() - 2419200000).toISOString().split('T')[0], // current date minus month
            toDate: new Date().toISOString().split('T')[0]
        }
    },
    mutations,
    actions
}

export default clientRefillHistory
